import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

// Styling
import { withStyles } from 'material-ui/styles';
import styles from './styles';

// Material UI
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';

// Actions
import { openSideDrawer } from './actions';

class NavIcon extends Component {
  render(){
    const { classes } = this.props;
    return(
      <div>
        <IconButton
          color="contrast"
          aria-label="open drawer"
          onClick={() =>this.props.openSideDrawer(true)}
          className={classes.navIconHide}
        >
          <MenuIcon />
        </IconButton>
      </div>
    );
  }
}

NavIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        sideDrawerOpen: state.dashboard.sideDrawerOpen,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      openSideDrawer: openSideDrawer,
    }, dispatch);
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(NavIcon));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ApplicationBar/components/ToolBar/components/NavIcon/index.js